export default `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96" width="96" height="96">
  <circle cx="48" cy="48" r="48" fill="#B1E971"/>
  <g transform="translate(0,96) scale(0.016667,-0.016667)">
    <path d="M1995 4309 c-38 -5 -92 -16 -120 -23 -27 -8 -70 -17 -95 -21 -75 -12
-247 -88 -390 -173 -47 -27 -168 -121 -229 -176 -44 -41 -179 -209 -213 -266
-87 -146 -153 -296 -173 -390 -7 -36 -21 -99 -31 -140 -25 -106 -25 -375 0
-480 10 -41 24 -104 31 -140 19 -97 90 -255 178 -397 44 -72 180 -236 225
-273 20 -16 66 -53 101 -82 128 -105 364 -224 501 -253 36 -7 99 -21 140 -31
105 -25 375 -25 480 0 41 10 104 24 140 31 94 20 242 85 390 173 47 27 168
121 229 176 44 41 179 209 213 266 87 146 153 296 173 390 7 36 21 97 30 135
10 42 19 137 22 236 6 166 6 166 -18 182 -21 15 -73 17 -499 17 -357 0 -479 3
-488 12 -20 20 -14 101 11 149 13 24 29 61 36 82 19 57 86 162 158 249 88 107
277 249 370 278 21 7 52 21 69 31 38 23 258 59 362 59 70 0 246 -21 312 -37
14 -4 45 -17 69 -30 24 -12 51 -23 60 -23 14 -1 93 -48 182 -108 128 -87 300
-298 339 -418 7 -21 21 -51 31 -68 27 -47 59 -243 59 -366 0 -123 -32 -319
-59 -366 -10 -17 -24 -47 -31 -68 -18 -54 -84 -161 -152 -243 -96 -116 -275
-251 -375 -283 -21 -7 -52 -21 -69 -31 -17 -10 -87 -27 -165 -40 -73 -12 -143
-23 -155 -25 -35 -6 -44 -46 -44 -199 0 -134 2 -147 21 -166 19 -19 28 -20 88
-14 36 3 98 13 136 22 39 8 99 21 135 28 94 20 244 86 390 173 57 34 225 169
266 213 55 61 149 182 176 229 88 148 153 296 173 390 7 36 21 99 31 140 25
105 25 375 0 480 -10 41 -24 104 -31 140 -20 94 -85 242 -173 390 -27 47 -121
168 -176 229 -41 44 -209 179 -266 213 -146 87 -296 153 -390 173 -36 7 -99
21 -140 31 -105 25 -375 25 -480 0 -41 -10 -104 -24 -140 -31 -94 -20 -242
-85 -390 -173 -47 -27 -168 -121 -229 -176 -44 -41 -179 -209 -213 -266 -87
-146 -153 -296 -173 -390 -7 -36 -21 -96 -30 -135 -10 -42 -19 -137 -22 -236
-6 -166 -6 -166 18 -182 21 -15 73 -17 499 -17 357 0 479 -3 488 -12 20 -20
14 -101 -11 -149 -13 -24 -29 -61 -36 -82 -19 -55 -85 -161 -153 -244 -96
-116 -275 -251 -375 -283 -21 -7 -51 -20 -68 -30 -46 -28 -243 -60 -365 -60
-122 0 -319 32 -365 60 -16 10 -47 23 -68 30 -92 29 -280 168 -355 262 -26 33
-58 74 -71 90 -37 46 -88 133 -102 175 -6 21 -18 47 -26 58 -18 27 -29 71 -48
194 -19 132 -19 230 0 362 19 123 30 167 48 194 8 11 20 37 27 58 18 57 85
162 157 249 93 112 276 247 382 283 28 9 53 21 56 25 8 14 66 27 190 45 61 8
119 17 131 20 35 8 44 47 44 200 0 132 -2 147 -20 165 -22 22 -36 22 -145 9z" fill="#00333E"/>
  </g>
</svg>`;
